import { Component, OnInit, Input, DoCheck, EventEmitter, Output, IterableDiffers, IterableDiffer} from '@angular/core';
import { Column } from 'src/app/reports/components/report/models/column.model';
import { ReportEntity } from '../../../models/report-entity.model';
import { RTEAlertService } from 'rte-library';
import { getOrderOfGroupColumn, orderPreviusList, sortListByOrder } from 'src/app/reports/helpers/column.helper';
import { OpenColumnOptions } from '../../column-options/open-column-options.model';
import { ColumnOptionsService } from '../../column-options/column-options.service';

@Component({
  selector: 'app-column',
  templateUrl: './column.component.html',
  styleUrls: ['./column.component.scss']
})
export class ColumnComponent implements OnInit, DoCheck {

  @Input() sessionId: string;
  @Input() disabled = false;
  @Input() columns: Array<Column> = new Array<Column>();
  @Input() columnDragulaGroup: string;
  @Input() reportEntities: Array<ReportEntity> = [];

  // Enable Two Way Data Biding
  @Output() columnsChange = new EventEmitter<Array<Column>>();

  displayedColumns: Array<string> = ['Order', 'Name', 'Alias', 'Action'];

  differ: IterableDiffer<any>;

  //#region Ctor

  constructor(private differs: IterableDiffers,
    private alert: RTEAlertService,
    private columnOptionService: ColumnOptionsService) {
  }

  //#endregion

  //#region Interface implementations

  ngOnInit() {
    this.differ = this.differs.find(this.columns).create(null);
  }

  ngDoCheck() {
    if (this.differ.diff(this.columns)) {

      setTimeout(() => {
        this.columnsChange.emit(this.columns);
      }, 0);
    }
  }

  //#endregion


  //#region  Events

  onDeleteClick(column: Column) {
    const aux = this.columns.concat();
    const index = aux.indexOf(column);

    if (index !== -1) {
      aux.splice(index, 1);
      this.columns = aux;
    }
  }

  onMoreOptionsClicked(event: MouseEvent, column: Column) {
    const obj: OpenColumnOptions = {
      event: event,
      data: column,
      sessionId: this.sessionId
    };

    this.columnOptionService.openColumnOptions(obj);
  }

  onGroupByChange(column: Column) {
    const validation = this.validateGroupByColumns();

    if (validation) {
      this.alert.warning(validation);

      setTimeout(() => {
        column.IsGroupBy = false;
      }, 0);

    } else {
      const order = getOrderOfGroupColumn(1, column, this.columns);

      if (column.Order !== order) {
        column.Order = order;

        orderPreviusList(column.Order, this.columns);
        this.columns = sortListByOrder(this.columns, true);
      }
    }
  }

  //#endregion

  //#region Validation

  getAliasErrorMessage(value): string {
    let msg = '';
    if (!value) {
      msg = 'É necessário informar o alias da coluna';
    } else if (this.verifyIfAliasExists(value)) {
      msg = 'Alias já informado';
    }

    return msg;
  }

  verifyIfAliasExists(value): boolean {
    return this.columns.find(item => {
      return item.Alias === value;
    }) != null;
  }

  validateGroupByColumns(): string {
    let validation = '';
    const groupColumnLength = this.columns.filter(x => x.IsGroupBy).length;

    if (groupColumnLength === this.columns.length) {
      validation = 'Não é permitido agrupar todas as colunas';
    }

    return validation;
  }

  //#endregion
}
